import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import { Locale } from '../core/constants';

const BASE_URL = 'https://tabist.co.jp';

function generateSiteMap(links: string[]) {
  return `<?xml version="1.0" encoding="UTF-8"?>
<sitemapindex xmlns="http://www.google.com/schemas/sitemap/0.9">
${links
  .map((link) => {
    return `
<sitemap>
  <loc>${`${BASE_URL}${link}`}</loc>
</sitemap>
`;
  })
  .join('')}
</sitemapindex>`;
}

const SiteMap = () => {
  return null;
};

export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  // We generate the XML sitemap with the posts data
  if (
    process.env.NEXT_PUBLIC_VERCEL_ENV === 'production' ||
    process.env.VERCEL_GIT_COMMIT_REF === 'stg'
  ) {
    const links = Object.values(Locale).map((locale) => `/sitemap/${locale}.xml`);
    const sitemap = generateSiteMap(links);

    context.res.setHeader('Content-Type', 'application/xml');
    // we send the XML to the browser
    context.res.write(sitemap);
    context.res.end();
  }

  return {
    props: {},
  };
};

export default SiteMap;
